import { useState } from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import { ChevronDown } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Form, FormField } from '@/components/ui/form'
import { FormFieldset } from '@/components/ui/form-field/fieldset'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'

import DialogPreviewCv from './dialog-preview-cv'

export default function GenerateCv() {
  const [isOpenFormJapan, setIsOpenFormJapan] = useState(false)
  const [isOpenPreviewCv, setIsOpenPreviewCv] = useState(false)

  const handleOpenPreviewCv = () => {
    setIsOpenFormJapan(false)
    setIsOpenPreviewCv(true)
  }

  const handleClickGenerateCv = () => {
    handleOpenPreviewCv()
  }

  return (
    <>
      <DialogFormCVJapan
        open={isOpenFormJapan}
        setOpen={setIsOpenFormJapan}
        handleGenerate={handleClickGenerateCv}
      />
      <DialogPreviewCv open={isOpenPreviewCv} setOpen={setIsOpenPreviewCv} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline_yes">
            Generate CV
            <div className="justify-self-end">
              <ChevronDown />
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" forceMount>
          <DropdownMenuItem
            className="hover:cursor-pointer"
            onClick={handleOpenPreviewCv}
          >
            CV Bahasa Jepang
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}

interface DialogFormCVJapanProps {
  open: boolean
  setOpen: (open: boolean) => void
  handleGenerate: () => void
}

interface FormGenerateCv extends z.infer<typeof FormGenerateCvDto> {}

const FormGenerateCvDto = z.object({
  name_kana: z.string(),
  address_kana: z.string(),
  summary: z.string(),
})

function DialogFormCVJapan({
  open,
  setOpen,
  handleGenerate,
}: DialogFormCVJapanProps) {
  const form = useForm<FormGenerateCv>({
    resolver: zodResolver(FormGenerateCvDto),
    defaultValues: {
      name_kana: '',
      address_kana: '',
      summary: '',
    },
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Form {...form}>
        <form>
          <DialogContent>
            <DialogHeader className="flex justify-between">
              <DialogTitle className="flex justify-center">
                Generate CV
              </DialogTitle>
            </DialogHeader>
            <div className="flex flex-col gap-6">
              <FormField
                control={form.control}
                name={'name_kana'}
                render={({ field }) => (
                  <FormFieldset label="Nama Dalam Kana">
                    <Input
                      placeholder="Masukkan alamat dalam kana"
                      {...field}
                    />
                  </FormFieldset>
                )}
              />
              <FormField
                control={form.control}
                name={'address_kana'}
                render={({ field }) => (
                  <FormFieldset label="Alamat Dalam Kana">
                    <Input
                      placeholder="Masukkan alamat dalam kana"
                      {...field}
                    />
                  </FormFieldset>
                )}
              />
              <FormField
                control={form.control}
                name={'summary'}
                render={({ field }) => (
                  <FormFieldset label="Ringkasan profil / skill / pengalaman">
                    <Textarea
                      placeholder="Ceritakan  tentang anda"
                      {...field}
                    />
                  </FormFieldset>
                )}
              />
            </div>
            <DialogFooter className="mt-4">
              <Button variant="primary" onClick={handleGenerate}>
                Generate CV
              </Button>
            </DialogFooter>
          </DialogContent>
        </form>
      </Form>
    </Dialog>
  )
}
